<template>
  <div class="box">
    <div class="center-box">
        <div class="center-heard">
          <img :src="heardIcon">
        </div>
      <p>用户名：{{this.$store.state.userInfo.nickname}}</p>
      <p class="vip">{{ISVIP.vip === 1 ? '会员用户' : '普通用户'}}</p>
<!--      <div class="center-btn">-->
<!--        <el-button round>普通用户</el-button>-->
<!--      </div>-->
    </div>
    <div class="center-list">
        <div class="vip-time" v-if="ISVIP.vip === 1">会员有效期限：{{ISVIP.expirationTime}}</div>
        <div class="vip-time" v-else></div>
        <img :src="iconWYGM" @click="buyVip()"/>
        <img :src="iconWYKP" @click="tolink()"/>
        <img :src="pc_icon_14" @click="dialogVisible = true"/>
        <img :src="iconWYSC" @click="toShouCang('/collection')"/>
    </div>
    <el-dialog
            title="小程序二维码"
            :visible.sync="dialogVisible"
            width="30%">
      <div>
        <div class="ewm-box">
          <img :src="ewm" class="ewm-icon"/>
        </div>
        <p class="ewx-title">税法税便问</p>
        <p class="ewx-content">打开微信扫一扫，即可查看小程序</p>
      </div>
        <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import heardIcon from '@/assets/tx.png'
  import vip from '@/assets/vip.png'
  import pc_icon_13 from '@/assets/pc_icon_13.png'
  import pc_icon_14 from '@/assets/pc_icon_14.png'
  import iconWYSC from '@/assets/iconWYSC.png'

  

  // 
  import iconWYKP from '@/assets/iconWYKP.png'
  import iconWYGM from '@/assets/iconWYGM.png'

  import { API_DATA } from "@/api/index";

  import ewm from '@/assets/ewm.jpg'
  import config from '@/config'
  const mallUrl = config[process.env.NODE_ENV].mallUrl;
  const mallOrderUrl = config[process.env.NODE_ENV].mallOrderUrl
  const passportUrl = config[process.env.NODE_ENV].passportUrl
  export default {
    data(){
      return{
        heardIcon,
        pc_icon_13,
        pc_icon_14,
        iconWYSC,
        iconWYKP,
        iconWYGM,
        vip,
        ewm,
        dialogVisible:false
      }
    },
    computed: {
      ISVIP () {
				let expirationTime = this.$store.state.isVip.expirationTime
				console.log(expirationTime)
				let data = {
					vip: this.$store.state.isVip.vip,
					expirationTime: expirationTime === null ? expirationTime : expirationTime.slice(0, 10)
				}
				return data
			}
    },
    
    mounted(){
      this.link =
      process.env.NODE_ENV == "development"
        ? "https://inte-store.chanjet.com/purchase?&agentCode=&csparam=&productId=4347&channel=asktax&buyAgain=1&orgId=" +
          this.$route.query.orgId +
          "&successBackBtnLabel=%e5%90%8c%e6%84%8f%e6%89%8b%e6%9c%ba%e5%8f%b7%e6%8e%88%e6%9d%83%e5%b9%b6%e4%bd%93%e9%aa%8c&callback=https%3a%2f%2finte-www.chanjet.com%2fnews%2ff%2f101593.html"
        : "https://store.chanjet.com/wap/purchase?&agentCode=&csparam=&productId=4347&channel=asktax&buyAgain=1&orgId=" +
          this.$route.query.orgId +
          "&successBackBtnLabel=%e5%90%8c%e6%84%8f%e6%89%8b%e6%9c%ba%e5%8f%b7%e6%8e%88%e6%9d%83%e5%b9%b6%e4%bd%93%e9%aa%8c&callback=https%3a%2f%2fwww.chanjet.com%2fnews%2ff%2f102658.html";
    },
    methods:{
      // 跳转我的订单
      tolink(){
        window.open(mallOrderUrl, '_blank');
      },
      //购买会员
      buyVip() {
        if (this.$store.state.cjt === true) {
          // window.location.href = this.link;
          window.open(this.link);
        } else {
          // window.location.href = mallUrl;
          window.open(mallUrl);
        }
      },
      //跳转收藏详情
      toShouCang(url){
        if (
          this.$store.state.userInfo.id == "" ||
          this.$store.state.userInfo.id == undefined ||
          this.$store.state.userInfo.id == null
        ) {
          this.$confirm("请登录后再查看", "提示", {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$store.commit("userDetail", "");
              window.location.href =
                passportUrl +
                "?client_id=sbw&redirectUrl=" +
                window.location.href;
            })
            .catch(() => {
              // this.$router.push("/" + window.location.search);
              // this.avtion = "/";
            });
        } else {
          this.isVip();
          console.log(url + window.location.search);
          this.$router.push(url + window.location.search);
        }
        //this.$router.push('/collection')
        //this.$router.push( '/collection')
      },
      //获取vip信息
      isVip() {
        API_DATA.isVip()
          .then((res) => {
            this.$store.commit("isVip", res.data);
            localStorage.setItem('isVip', res.data)
          })
          .catch((err) => {
            console.log(err);
          });
      },
    },
    
  }
</script>
<style lang="scss" scoped>
  .box{
    overflow: hidden;
    width: 100%;
    // margin-bottom: 100px;
  }
  .center-box{
    width: 990px;
    min-height: 132px;
    padding: 30px 0px;
    background-color: #2270e6;
    box-shadow: 0px 2px 6px 0px
    rgba(194, 200, 211, 0.14);
    border-radius: 10px;
    margin-top: 10px;
    text-align: center;
  }
  .center-heard{
    width: 90px;
    height: 90px;
    margin: 0 auto;
  }
  .center-heard >img{
    width: 100%;
    height: 100%;
  }
  .center-box >p{
    text-align: center;
    font-size: 18px;
    color: #ffffff;
    margin: 16px 0px 20px 0px;
  }
  .center-btn{
    text-align: center;
  }
  .center-btn /deep/ .el-button{
    width: 100px;
    height: 30px;
    line-height: 30px;
    padding: 0px;
    background-color: transparent;
    color: #fff;
  }
  .center-list{
    width: 990px;
    min-height: 166px;
    padding: 0 0px 90px;
    background-color: #ffffff;
    box-shadow: 0px 2px 6px 0px
    rgba(194, 200, 211, 0.14);
    border-radius: 10px;
    margin-top: 10px;
    overflow: hidden;
    text-align: center;
    margin-bottom: 20px;
  }
  .center-list >img{
    width: 150px;
    height: 150px;
    display: inline-block;
    margin-right: 80px;
    cursor: pointer;
  }
  .center-list >img:last-child{
    margin-right: 0px;
    width: 150px;
    height: 150px;
    display: inline-block;
    cursor: pointer;
  }
  .ewm-box{
    width: 198px;
    height: 198px;
    margin: 0 auto;
  }
  .ewm-icon{
    width: 100%;
    height: 100%;
  }
  .ewx-title{
    font-size: 20px;
    color: #222222;
    font-weight: 600;
    text-align: center;
  }
  .ewx-content{
    font-size: 16px;
    color: #222222;
    text-align: center;
  }
  .vip{
    display: inline-block;
    padding: 5px 15px;
    border: 1px solid #FFFFFF;
    border-radius: 100px 100px 100px 100px;
  }
  .vip-time{
    width: 100%;
    min-height: 40px;
    font-size: 28px;
    color: #c95050;
    margin: 40px 0;
  }
</style>